<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import P from "../components/P.svelte";
  import LicenseChip from "../components/LicenseChip.svelte";
  import LicenseChips from "../components/LicenseChips.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps, style as licenseStyle } from "../utils";

  /**
    @typedef {Object} Props
    @property {string} style
  */

  /** @type {Props}*/
  let { style } = $props();

  const iconProps = getIconProps("outreach");
</script>

<Slide {style}>
  <LicenseChips style={licenseStyle}>
    <LicenseChip license="outreach" />
    <LicenseChip license="extension" />
    <LicenseChip license="data" />
    <LicenseChip license="dataRefresh">Data Refresh</LicenseChip>
  </LicenseChips>
  <H1>Build and nurture your network</H1>
  <P>
    SourceWhale makes it a breeze to view, contact and manage candidates and
    clients all in one place.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-user-magnifying-glass" {...iconProps} />View, search
      and interact with your network
    </Bullet>
    <Bullet>
      <IconScale class="fa-inboxes" {...iconProps} />Organise and manage
      contacts in Projects
    </Bullet>
    <Bullet>
      <IconScale class="fa-upload" {...iconProps} />Upload lists of people to
      contacts or campaigns
    </Bullet>
  </Bullets>
  <CTAs tourLink="https://sourcewhale.navattic.com/t3q0sf2" />
</Slide>
